var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{attrs:{"label":"Help Icon"},on:{"change":_vm.onChange},model:{value:(_vm.switchValue),callback:function ($$v) {_vm.switchValue=$$v},expression:"switchValue"}}),_c('keep-alive',[(_vm.switchValue)?_c('help-icon-inputs',{attrs:{"value":_vm.value},on:{"helpDataChanged":_vm.handleInputsChange}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }